import React from "react";
import './Admin.css';
import TransactionDataService from "../../services/transaction.service";
import SignupDataService from "../../services/signup.service";
import moment from "moment";


  class AdminTransaction extends React.Component{

    constructor(props) {
      super(props);
      const isLoggedIn = window.localStorage.getItem("userid") ? true : false;
      let userid = 0;
    
      if(isLoggedIn)
      {
      userid = window.localStorage.getItem("userid");
  
      }
      this.state = {
        list: []
  
      };
    }

    componentDidMount() {

      TransactionDataService.getAll()
      .then(res => {
          if(res.data !== '')
          {
           
            res.data.forEach(res1 => {
              SignupDataService.get(res1.userid)
              .then(result => {

                var data = {
                  id: res1.userid,
                  name: result.data.name,
                  sessionid : res1.data.sessionid,
                  price : res1.data.price,
                  createdAt : moment(res.data.createdAt).format('LLL'),
                  email: result.data.email
                 
              }
  
  
              this.setState({
                list: [
                ...this.state.list,
                 data
                ]
              }); 
              });
             

            })

          }
         
          
      })
    }

    render(){
      return (
    <div className="row col-md-12">
        {
            this.state.list !== []  && this.state.list.length > 0 ?
            <div>
            <table responsive className="table">
            <thead>
              <tr>
               <td>Name</td>
                <td>Session Id</td>
                <td>Price</td>
                <td>User Id</td>
                <td>Created</td>
                <td></td>
                </tr>
            </thead>
            <tbody>
            {
            this.state.list.map((log,index) => (
                        <tr key={index+"top_key"}>
                        <td key={index + "_a"} className="table-text-color">{log.name}</td>  
                        <td key={index + "_a"} className="table-text-color">{log.sessionid}</td>  
                        <td key={index + "_b"} className="table-text-color">{log.price}</td>  
                        <td key={index + "_c"} className="table-text-color">{log.userid}</td> 
                        <td key={index + "_f"} className="table-text-color">{log.createdAt}</td>   
                       
                      </tr>
                                   
                    ))
            }
            </tbody>
            </table>
            </div>
         
          : <span className="table-text-color">No Transactions found</span>

        }
    </div>
    
      )
      }
}



export default AdminTransaction;